export { PREDICATE_VERSIONS } from './generated/predicates';
